
























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ExpansionPanel extends Vue {

    @Prop(Object) panel!: object
    @Prop(Number) expand!: number

    expandCustom: number = 0;

    data() {
      return {
        expandCustom: 0
      }
    }

    mounted() {
      this.expandCustom = this.expand;
    }

    closePanel() {
      this.expandCustom += 1;
    }

}
